<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加项目"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="800px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="80px"
      >
        <el-form-item label="项目名称：" prop="projectName">
          <el-input size="mini" v-model.trim="form.projectName" placeholder="请输入项目名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人：" class="mr0">
          <el-input
            size="mini"
            v-number-only:11
            v-model.trim="form.contacts"
            placeholder="请输入联系人"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input
            size="mini"
            v-number-only:11
            v-model.trim="form.contactTelephone"
            placeholder="请输入联系电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话2：" class="mr0">
          <el-input
            size="mini"
            v-number-only:11
            v-model.trim="form.contactTelephone2"
            placeholder="请输入联系电话2"
            clearable
          ></el-input>
        </el-form-item>
        <AddreassSelect :warning="addressWarn" class="input-with-col2" @change="setPojectAddress"></AddreassSelect>

        <el-form-item label="使用单位：" prop="propertyUnitName">
           <el-input size="mini" v-model.trim="form.propertyUnitName" placeholder="请输入使用单位" clearable></el-input>
        </el-form-item>

        <el-form-item label="电销模板：" prop="telemarketingTemplateId">
          <el-select
            size="mini"
            v-model="form.telemarketingTemplateId"
            filterable
            placeholder="请选择电销模板："
            clearable
            reserve-keyword
            :remote="false"
            :remote-method="searcTelemarketingTemplateList"
            @visible-change="searcTelemarketingTemplateList('')"
            value-key="id"
          >
            <el-option
              v-for="item in telemarketingTemplateList"
              :key="item.id"
              :label="item.templateName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟踪模板：" prop="trackTemplateId">
          <el-select
            size="mini"
            v-model="form.trackTemplateId"
            filterable
            placeholder="请选择跟踪模板"
            clearable
            reserve-keyword
            :remote="false"
            :remote-method="searcTrackTemplateList"
            @visible-change="searcTrackTemplateList('')"
            value-key="id"
          >
            <el-option
              v-for="item in trackTemplateList"
              :key="item.id"
              :label="item.templateName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addProject, getDepartmentList, getUnitSimpleList, getTrackTemplateList, getTelemarketingTemplateList  } from "@/api/salesManagement/ProjectManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";

export default {
  data() {
    return {
      form: {
        contactTelephone: "",
        contacts: "",
        contactTelephone2: "",
        address: "",
        cityCode: "",
        projectName: "",
        districtCode: "",
        provinceCode: "",
        propertyUnitName: "",
        telemarketingTemplateId: null,
        trackTemplateId: null
      },
      addressWarn: false,
      rules: {
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        telemarketingTemplateId: [
          {
            required: true,
            message: "请选择电销模板",
            trigger: "change",
          },
        ],
        trackTemplateId: [
          {
            required: true,
            message: "请选择跟踪模板",
            trigger: "change",
          },
        ],
        propertyUnitName: [
          {
            required: true,
            message: "请输入使用单位",
            trigger: "blur",
          },
        ]
      },
      loadBtn: false,
      unitList: [],
      departmentList: [],
      propertyObj: {},
      departmentObj: {},
      trackTemplateList: [],
      telemarketingTemplateList: []
    };
  },
  components: {
    AddreassSelect,
  },
  created() {
    // this.searchUnitList();
    this.searchDepartmentList();
    this.searcTrackTemplateList();
    this.searcTelemarketingTemplateList();
  },
  methods: {
    async searcTrackTemplateList(keyword) {
      const res = await getTrackTemplateList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.trackTemplateList = res.data;
      }
    },
    async searcTelemarketingTemplateList(keyword) {
      const res = await getTelemarketingTemplateList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.telemarketingTemplateList = res.data;
      }
    },
    async searchDepartmentList(keyword) {
      const res = await getDepartmentList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await addProject(this.form);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
    chooseProperty(data) {
      if (data && data.id) {
        this.form.propertyUnitId = data.id
        this.form.propertyUnitName = data.unitName
      } else {
        this.form.propertyUnitId = ''
        this.form.propertyUnitName = ''
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/AddProject.vue